<template>
  <div>
    <demandActionButton
      style="padding-top: 20px"
      :disabled="countDown == 0"
      page="4"
      button1-string="戻る"
      :button1-action="cancelTentativeReservation"
      button2-string="この内容で確定する"
      :button2-action="putApprove"
    />
    <!-- 有効化処理ローディングダイアログ -->
    <ItemDialog ref="dialogLoading" image-type="loader" />

    <!-- 失敗ダイアログ -->
    <ItemDialog ref="dialogFails" image-type="alert">
      <template #content-area>
        <h2>エラーが発生しました</h2>
        <p class="text-center">お手数ですが最初からやり直してください</p>
      </template>
      <template #button-area>
        <ItemButton
          label="戻る"
          action-type="btn-primary"
          @clicked="gotoIndex"
        />
      </template>
    </ItemDialog>
    <!-- 失敗ダイアログ -->

    <!-- 失敗ダイアログ -->
    <ItemDialog
      ref="dialogCancelTentativeReservationComplete"
      image-type="alert"
    >
      <template #content-area>
        <p class="text-center">お手数ですが人数選択からやり直してください</p>
      </template>
      <template #button-area>
        <ItemButton
          label="戻る"
          action-type="btn-primary"
          @clicked="gotoBooking2"
        />
      </template>
    </ItemDialog>
    <!-- 失敗ダイアログ -->
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import API from "@/API";

export default {
  name: "TheDemandActionButton4",
  props: {
    selectedService: {
      type: Object,
      require: true,
    },
    tentativeReservation: {
      type: Object,
      require: true,
    },
    countDown: {
      typr: Number,
      require: true,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const paymentMethods = store.getters["demand/paymentMethods"];

    const dialogLoading = ref();
    const dialogFails = ref();
    const dialogCancelTentativeReservationComplete = ref();

    const putApprove = async () => {
      dialogLoading.value.open();
      try {
        var paymentMethodsArray = await createAPIparams();

        const apiParams = {
          master_bookingservice_id:
            props.selectedService.master_bookingservice_id,
          id: props.tentativeReservation.id,
          passengers: paymentMethodsArray,
        };

        console.log("apiParams :>> ", apiParams);
        const reservation = await API.putApproveReservation(
          apiParams,
          props.tentativeReservation
        );
        await gotoDemandEbusConfirmation(reservation.id);
      } catch (err) {
        console.log("err :>> ", err);
        dialogFails.value.open();
      }
    };

    const createAPIparams = async () => {
      // APIのリクエスト用に整形し直す
      var paymentMethodsArray = [];
      console.log("paymentMethods :>> ", paymentMethods);

      paymentMethods.forEach((object, index) => {
        console.log("key :>> ", Object.keys(object)[0]);
        console.log("value :>> ", Object.values(object)[0]);
        console.log("index :>> ", index);

        paymentMethodsArray.push({
          division: Object.keys(object)[0],
          payment_method: Object.values(object)[0],
        });
      });

      return paymentMethodsArray;
    };

    const gotoDemandEbusConfirmation = async (reservation_id) => {
      router.push({
        name: "DemandEbusConfirmation",
        query: { id: reservation_id },
      });
    };

    const gotoIndex = async () => {
      router.push({
        name: "DemandIndex",
      });
    };

    // カウントダウンが0以上であれば、ページを戻る前に仮予約をキャンセル必要がある
    const cancelTentativeReservation = async () => {
      if (props.countDown > 0) {
        dialogLoading.value.open();
        await API.putDeclineEbusTentativeReservation(
          props.tentativeReservation.id
        );
        dialogLoading.value.close();
        dialogCancelTentativeReservationComplete.value.open();
      } else {
        dialogCancelTentativeReservationComplete.value.open();
      }
    };

    const gotoBooking2 = () => {
      // -1だと、キャンセル前のpickupTimeを引用するため、ラッパーで弾かれるので時間を選択するbooking2まで戻る必要あり
      router.go(-2);
    };
    return {
      dialogLoading,
      dialogFails,
      dialogCancelTentativeReservationComplete,
      putApprove,
      gotoIndex,
      cancelTentativeReservation,
      gotoBooking2,
    };
  },
};
</script>
